export default function videoOverlay(divId) {
  const YT_STATE = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
  };

  const QUALITY_CHECK_INTERVAL = 1000; // 1 second
  const FIRST_ELEMENT = 0;

  const videoSection = $(divId)[FIRST_ELEMENT];
  let videoStarted = false;
  let lastQuality = null;

  if (!videoSection) return;

  const id = videoSection.dataset.id;
  const volumeBtn = $('#cover-block-video-overlay-volume-btn');
  const videoOverlay = $('#cover-block-video-overlay');

  // Ensure video container is visible and properly positioned
  videoOverlay.css({
    visibility: 'visible',
    display: 'block',
    position: 'absolute',
    width: '177.77777778vh',
    height: '100%',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    'min-width': '100%',
    'min-height': '56.25vw',
    'z-index': '1',
    opacity: '0',
    transition: 'opacity 0.5s ease-in-out'
  });

  // Create a hidden iframe for preloading at higher quality
  const preloadFrame = document.createElement('iframe');
  preloadFrame.style.position = 'absolute';
  preloadFrame.style.left = '-9999px';
  preloadFrame.style.top = '-9999px';
  preloadFrame.style.width = '3840px';
  preloadFrame.style.height = '2160px';
  preloadFrame.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${id}&vq=hd1080&hd=1&enablejsapi=1&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3&fs=0&disablekb=1&playsinline=1&origin=${window.location.origin}&widget_referrer=${window.location.href}&background=1`;
  document.body.appendChild(preloadFrame);

  function initPlayer() {
    const preloadPlayer = new window.YT.Player(preloadFrame, {
      events: {
        onReady: () => {
          // Create the main player in the target container
          // eslint-disable-next-line no-unused-vars
          const mainPlayer = new window.YT.Player(videoSection, {
            height: '100%',
            width: '100%',
            videoId: id,
            playerVars: {
              controls: 0,
              loop: 1,
              playlist: id,
              mute: 1,
              autoplay: 1,
              playsinline: 1,
              modestbranding: 1,
              rel: 0,
              fs: 0,
              disablekb: 1,
              origin: window.location.origin
            },
            events: {
              onReady: (event) => {
                // Set up volume controls
                volumeBtn.on('click', () => {
                  if (event.target.isMuted()) {
                    volumeBtn.children('#mute-icon').addClass('v2-hidden');
                    volumeBtn.children('#unmute-icon').removeClass('v2-hidden');
                    event.target.unMute();
                  } else {
                    volumeBtn.children('#mute-icon').removeClass('v2-hidden');
                    volumeBtn.children('#unmute-icon').addClass('v2-hidden');
                    event.target.mute();
                  }
                });

                // Ensure iframe is hidden initially
                const iframe = event.target.getIframe();
                if (iframe) {
                  iframe.style.opacity = '0';
                  iframe.style.visibility = 'hidden';
                  iframe.setAttribute('tabindex', '-1');
                  iframe.setAttribute('focusable', 'false');
                  iframe.setAttribute('allow', 'autoplay');
                }

                event.target.playVideo();
              },
              onStateChange: (event) => {
                // Force play if video gets paused
                if (event.data === YT_STATE.PAUSED) {
                  event.target.playVideo();
                  return;
                }

                // Hide related videos during buffering
                if (event.data === YT_STATE.BUFFERING) {
                  // Buffering
                  const iframe = event.target.getIframe();
                  if (iframe) {
                    const relatedVideos = iframe.contentDocument?.querySelector(
                      '.ytp-pause-overlay'
                    );
                    if (relatedVideos) {
                      relatedVideos.style.display = 'none';
                    }
                  }
                }

                if (event.data === YT_STATE.PLAYING) {
                  // Playing
                  const quality = preloadPlayer.getPlaybackQuality();

                  // Always set the quality, even during loops
                  if (quality && quality !== lastQuality) {
                    event.target.setPlaybackQuality(quality);
                    lastQuality = quality;
                  }

                  if (!videoStarted) {
                    videoStarted = true;

                    // Keep playing but only show at full opacity when quality is at least 'hd720'
                    if (['tiny', 'small', 'medium'].includes(quality)) {
                      // Check quality every second until we get at least 'hd720'
                      const qualityCheck = setInterval(() => {
                        const currentQuality = event.target.getPlaybackQuality();

                        if (
                          !['tiny', 'small', 'medium'].includes(currentQuality)
                        ) {
                          clearInterval(qualityCheck);
                          event.target.setPlaybackQuality(currentQuality);
                          lastQuality = currentQuality;

                          // Show the iframe first
                          const iframe = event.target.getIframe();
                          if (iframe) {
                            iframe.style.visibility = 'visible';
                            iframe.style.opacity = '1';
                          }

                          // Then fade in the container
                          videoOverlay.css('opacity', '1');
                        }
                      }, QUALITY_CHECK_INTERVAL);
                      return;
                    }

                    // Only show if quality is already good enough
                    if (
                      !['tiny', 'small', 'medium', 'large'].includes(quality)
                    ) {
                      const iframe = event.target.getIframe();
                      if (iframe) {
                        iframe.style.visibility = 'visible';
                        iframe.style.opacity = '1';
                      }
                      videoOverlay.css('opacity', '1');
                    }
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  // Load YouTube API if not already loaded
  if (window.YT) {
    initPlayer();
  } else {
    window.onYouTubeIframeAPIReady = initPlayer;
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }
}
